// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__cqwauok3GoGGd","footer":"footer__mOQaEhiRmGDHs"};